import propTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

function AuthOnlyRoute({ Component }) {
  const isLoggedIn = useSelector((state) => state.auth.login);

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return <Component />;
}

AuthOnlyRoute.propTypes = {
  Component: propTypes.elementType.isRequired,
};

export default AuthOnlyRoute;
